import { useEffect, useState } from 'react';

export const useTheme = () => {
  const [theme, setTheme] = useState<string>();

  useEffect(() => {
    const loadingTheme = setInterval(() => {
      const tryGetTheme = localStorage.getItem('theme');

      if (tryGetTheme) {
        setTheme(tryGetTheme);

        clearInterval(loadingTheme);
      }
    }, 10);
  }, []);

  return { theme };
};
